var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _rect2, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _ellipse2, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgClearImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 120,
    viewBox: "0 0 186 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6970_232986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 13,
    width: 67,
    height: 94
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.73375,
    y: 14.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6970_232986)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.67188,
    y: 15.0566,
    width: 69.4819,
    height: 90,
    rx: 5.13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5788,
    y: 65.6881,
    width: 28.3746,
    height: 10.6544,
    rx: 4.395,
    fill: "#7CE9DA",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8678,
    y: 93.6647,
    width: 17.1828,
    height: 3.19321,
    rx: 1.59661,
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4279 88.3114H30.8811C32.1469 88.3114 33.1767 87.2416 33.1767 85.9275V73.4015C33.1767 72.0873 32.1468 71.0176 30.8811 71.0176H16.4279C15.1627 71.0176 14.1328 72.0873 14.1328 73.4015V85.9275C14.1328 87.2416 15.1627 88.3114 16.4279 88.3114ZM27.8155 87.0659H19.4941V86.2164C19.4941 84.6856 20.27 83.3472 21.4289 82.5795C22.0838 82.9993 22.844 83.2446 23.6574 83.2446C24.4691 83.2446 25.2276 82.9998 25.8813 82.5808C27.0397 83.3486 27.8155 84.6862 27.8155 86.2165V87.0659ZM20.4461 78.4435C20.4461 76.4793 21.8869 74.8817 23.6574 74.8817C25.425 74.8817 26.8634 76.4793 26.8634 78.4435C26.8634 80.4041 25.425 81.9991 23.6574 81.9991C21.887 81.9991 20.4461 80.404 20.4461 78.4435ZM15.3319 73.4015C15.3319 72.7738 15.8237 72.263 16.4279 72.263H30.8811C31.4858 72.263 31.9777 72.7738 31.9777 73.4015V85.9275C31.9777 86.5551 31.4859 87.0659 30.8811 87.0659H29.0145V86.2164C29.0145 84.3873 28.1537 82.771 26.8383 81.7557C27.5948 80.8933 28.0625 79.7277 28.0625 78.4433C28.0625 75.7926 26.0866 73.6361 23.6574 73.6361C21.2253 73.6361 19.247 75.7925 19.247 78.4433C19.247 79.7261 19.7143 80.8901 20.4697 81.7522C19.1535 82.767 18.295 84.3867 18.295 86.2164V87.0659H16.4279C15.8237 87.0659 15.3319 86.5551 15.3319 85.9275V73.4015Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.26 82.2266H41.687C41.2467 82.2266 40.8906 82.5675 40.8906 82.9886C40.8906 83.4099 41.2469 83.7506 41.687 83.7506H63.26C63.7003 83.7506 64.0564 83.4097 64.0564 82.9886C64.0564 82.5675 63.7003 82.2266 63.26 82.2266Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.26 85.8848H41.687C41.2467 85.8848 40.8906 86.2257 40.8906 86.6468C40.8906 87.0681 41.2469 87.4088 41.687 87.4088H63.26C63.7003 87.4088 64.0564 87.0679 64.0564 86.6468C64.0564 86.2257 63.7003 85.8848 63.26 85.8848Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7877 91.9805H41.4229C41.1286 91.9805 40.8906 92.3214 40.8906 92.7425C40.8906 93.1638 41.1287 93.5045 41.4229 93.5045H65.7877C66.082 93.5045 66.32 93.1636 66.32 92.7425C66.32 92.3212 66.082 91.9805 65.7877 91.9805Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7877 98.0762H41.4229C41.1286 98.0762 40.8906 98.4171 40.8906 98.8382C40.8906 99.2595 41.1287 99.6002 41.4229 99.6002H65.7877C66.082 99.6002 66.32 99.2593 66.32 98.8382C66.32 98.4169 66.082 98.0762 65.7877 98.0762Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6997 103.541C57.0791 102.889 57.4585 102.238 57.654 102.271C57.8494 102.304 57.8494 103.041 57.9592 103.095C58.069 103.149 58.2887 102.498 58.4018 102.428C58.515 102.358 58.515 102.889 58.515 103.129C58.515 103.3 58.8744 102.612 59.4689 101.917C59.6181 101.743 59.8038 102.319 59.8752 102.541C59.9466 102.762 59.9866 102.711 60.3765 101.99C60.7665 101.27 61.5053 99.882 61.9658 98.9614C62.4263 98.0408 62.586 97.6295 62.6983 97.3748C62.8105 97.1201 62.8704 97.0345 62.5818 98.4725C62.2932 99.9105 61.6542 102.875 61.1353 104.753C60.6165 106.632 60.2371 107.334 59.9717 107.756C59.7064 108.178 59.5666 108.298 59.3748 108.188C58.8078 107.864 58.5967 107.092 58.4055 106.428C58.299 106.058 58.2342 105.609 58.1931 105.106C58.1519 104.602 58.1519 104.054 58.3017 103.488C58.6103 102.324 59.2393 101.707 59.5615 101.611C59.6994 101.571 59.8038 101.602 59.8852 101.739C60.3274 102.485 59.6665 102.969 59.6837 103.09C59.7096 103.271 60.4597 103.245 59.7796 103.297C59.0995 103.35 57.1427 103.367 55.3459 103.316C53.5491 103.265 51.9716 103.145 51.2588 103.057C50.546 102.97 50.7457 102.918 52.9552 102.849C55.1646 102.78 59.3778 102.694 62.5567 102.496C65.7355 102.297 67.7522 101.989 69.8906 101.671",
    stroke: "#0F574E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.73375,
    y: 14.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.46875,
    y: 15.0566,
    width: 63.886,
    height: 43.8342,
    rx: 5.13,
    fill: "#E9FBF9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 58.8906H73.5855",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1565 44.9025C41.1666 44.9025 41.1763 44.9047 41.1863 44.9047C41.1963 44.9047 41.2041 44.9029 41.2131 44.9028C43.1863 44.8936 45.0755 44.1037 46.4675 42.7058C47.8595 41.308 48.641 39.4159 48.641 37.4436C48.641 35.4712 47.8595 33.5792 46.4675 32.1813C45.0755 30.7834 43.1863 29.9935 41.2131 29.9843C41.2041 29.9843 41.1953 29.9824 41.1863 29.9824C41.1773 29.9824 41.1666 29.9843 41.1565 29.9845C39.1817 29.991 37.2899 30.7797 35.8958 32.1778C34.5016 33.576 33.7188 35.4695 33.7188 37.4435C33.7188 39.4176 34.5016 41.3111 35.8958 42.7092C37.2899 44.1074 39.1817 44.8961 41.1565 44.9025ZM35.3879 39.6783C36.0818 40.0703 36.9702 40.3889 38.0223 40.606C38.2393 41.6568 38.5577 42.5444 38.9494 43.2379C38.141 42.9243 37.4069 42.4458 36.7937 41.833C36.1805 41.2201 35.7017 40.4863 35.3879 39.6783ZM37.814 39.2838C35.9409 38.8178 34.9661 38.0427 34.9661 37.4437C34.9661 36.8447 35.9409 36.07 37.814 35.6032C37.6799 36.8264 37.6799 38.0606 37.814 39.2838ZM41.1868 31.2266H41.1902C41.7892 31.2307 42.562 32.2043 43.0271 34.0727C41.8034 33.9384 40.5687 33.9384 39.345 34.0727C39.8104 32.2045 40.5829 31.2313 41.1819 31.2266C41.1836 31.2268 41.1852 31.2266 41.1868 31.2266ZM39.0987 35.3567C40.4839 35.1685 41.8883 35.1685 43.2735 35.3567C43.4622 36.7413 43.4622 38.1451 43.2735 39.5298C41.8883 39.7179 40.4839 39.7179 39.0987 39.5298C38.9105 38.1451 38.9105 36.7414 39.0987 35.3567ZM39.345 40.814C40.5687 40.9481 41.8034 40.9481 43.0271 40.814C42.5621 42.6826 41.7892 43.6559 41.1902 43.6601H41.1868C41.1852 43.6601 41.1836 43.6601 41.1819 43.6601C40.5829 43.6556 39.8102 42.6824 39.345 40.8145V40.814ZM43.4228 43.2379C43.8146 42.5443 44.133 41.6567 44.3499 40.6057C45.4018 40.3887 46.2902 40.0702 46.984 39.6783C46.6703 40.4863 46.1917 41.2202 45.5785 41.8331C44.9654 42.446 44.2313 42.9246 43.4229 43.2382L43.4228 43.2379ZM44.5583 35.6029C46.4317 36.0693 47.4063 36.8441 47.4063 37.4434C47.4063 38.0427 46.4317 38.8175 44.5583 39.2835C44.6928 38.0603 44.6928 36.8261 44.5583 35.6029ZM46.9841 35.2081C46.2902 34.8163 45.4018 34.4978 44.3499 34.2808C44.133 33.2298 43.8146 32.3421 43.4228 31.6486C44.2312 31.9622 44.9654 32.4407 45.5785 33.0536C46.1917 33.6665 46.6704 34.4004 46.9841 35.2085V35.2081ZM38.949 31.6492C38.5574 32.3427 38.239 33.2302 38.0221 34.2811C36.97 34.4982 36.0818 34.8168 35.3876 35.2089C35.7014 34.4009 36.1802 33.6671 36.7933 33.0542C37.4065 32.4414 38.1407 31.9629 38.949 31.6492Z",
    fill: "#168374"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 101.405V110.811C1 113.645 3.29795 115.943 6.13262 115.943H15.0187",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8516 101.405V110.811C80.8516 113.645 78.5536 115.943 75.7189 115.943H66.8329",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5953V9.18926C1 6.35459 3.29795 4.05664 6.13262 4.05664H15.0187",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8516 18.5953V9.18926C80.8516 6.35459 78.5536 4.05664 75.7189 4.05664H66.8329",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.4846,
    cy: 14.8128,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3203 7.11133C65.7072 7.11133 64.1302 7.57319 62.7889 8.4385C61.4477 9.30382 60.4023 10.5337 59.7849 11.9727C59.1676 13.4117 59.0061 14.9951 59.3208 16.5227C59.6355 18.0503 60.4123 19.4535 61.553 20.5548C62.6936 21.6561 64.147 22.4062 65.7291 22.71C67.3113 23.0139 68.9512 22.8579 70.4416 22.2619C71.9319 21.6658 73.2058 20.6565 74.102 19.3614C74.9982 18.0664 75.4766 16.5439 75.4766 14.9863C75.4766 12.8977 74.6172 10.8947 73.0877 9.41786C71.5581 7.94101 69.4835 7.11133 67.3203 7.11133ZM66.1551 18.1312L63.2422 15.3187L64.1689 14.4238L66.1551 16.3415L70.4721 12.1738L71.4018 13.0659L66.1551 18.1312Z",
    fill: "#00D492"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6970_232986)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6970_232986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 13,
    width: 67,
    height: 94
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.882,
    y: 14.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6970_232986)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.82,
    y: 15.0566,
    width: 69.4819,
    height: 90,
    rx: 5.13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.727,
    y: 65.6881,
    width: 28.3746,
    height: 10.6544,
    rx: 4.395,
    fill: "#7CE9DA",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.016,
    y: 93.6647,
    width: 17.1828,
    height: 3.19321,
    rx: 1.59661,
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.576 88.3114H135.029C136.295 88.3114 137.325 87.2416 137.325 85.9275V73.4015C137.325 72.0873 136.295 71.0176 135.029 71.0176H120.576C119.311 71.0176 118.281 72.0873 118.281 73.4015V85.9275C118.281 87.2416 119.311 88.3114 120.576 88.3114ZM131.964 87.0659H123.643V86.2164C123.643 84.6856 124.418 83.3472 125.577 82.5795C126.232 82.9993 126.992 83.2446 127.806 83.2446C128.618 83.2446 129.376 82.9998 130.03 82.5808C131.188 83.3486 131.964 84.6862 131.964 86.2165V87.0659ZM124.594 78.4435C124.594 76.4793 126.035 74.8817 127.806 74.8817C129.573 74.8817 131.012 76.4793 131.012 78.4435C131.012 80.4041 129.573 81.9991 127.806 81.9991C126.035 81.9991 124.594 80.404 124.594 78.4435ZM119.48 73.4015C119.48 72.7738 119.972 72.263 120.576 72.263H135.029C135.634 72.263 136.126 72.7738 136.126 73.4015V85.9275C136.126 86.5551 135.634 87.0659 135.029 87.0659H133.163V86.2164C133.163 84.3873 132.302 82.771 130.987 81.7557C131.743 80.8933 132.211 79.7277 132.211 78.4433C132.211 75.7926 130.235 73.6361 127.806 73.6361C125.374 73.6361 123.395 75.7925 123.395 78.4433C123.395 79.7261 123.863 80.8901 124.618 81.7522C123.302 82.767 122.443 84.3867 122.443 86.2164V87.0659H120.576C119.972 87.0659 119.48 86.5551 119.48 85.9275V73.4015Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.408 82.2266H145.835C145.395 82.2266 145.039 82.5675 145.039 82.9886C145.039 83.4099 145.395 83.7506 145.835 83.7506H167.408C167.849 83.7506 168.205 83.4097 168.205 82.9886C168.205 82.5675 167.849 82.2266 167.408 82.2266Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.408 85.8848H145.835C145.395 85.8848 145.039 86.2257 145.039 86.6468C145.039 87.0681 145.395 87.4088 145.835 87.4088H167.408C167.849 87.4088 168.205 87.0679 168.205 86.6468C168.205 86.2257 167.849 85.8848 167.408 85.8848Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.936 91.9805H145.571C145.277 91.9805 145.039 92.3214 145.039 92.7425C145.039 93.1638 145.277 93.5045 145.571 93.5045H169.936C170.23 93.5045 170.468 93.1636 170.468 92.7425C170.468 92.3212 170.23 91.9805 169.936 91.9805Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.936 98.0762H145.571C145.277 98.0762 145.039 98.4171 145.039 98.8382C145.039 99.2595 145.277 99.6002 145.571 99.6002H169.936C170.23 99.6002 170.468 99.2593 170.468 98.8382C170.468 98.4169 170.23 98.0762 169.936 98.0762Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.848 103.541C161.228 102.889 161.607 102.238 161.802 102.271C161.998 102.304 161.998 103.041 162.108 103.095C162.217 103.149 162.437 102.498 162.55 102.428C162.663 102.358 162.663 102.889 162.663 103.129C162.663 103.3 163.023 102.612 163.617 101.917C163.766 101.743 163.952 102.319 164.024 102.541C164.095 102.762 164.135 102.711 164.525 101.99C164.915 101.27 165.654 99.882 166.114 98.9614C166.575 98.0408 166.734 97.6295 166.847 97.3748C166.959 97.1201 167.019 97.0345 166.73 98.4725C166.442 99.9105 165.803 102.875 165.284 104.753C164.765 106.632 164.386 107.334 164.12 107.756C163.855 108.178 163.715 108.298 163.523 108.188C162.956 107.864 162.745 107.092 162.554 106.428C162.447 106.058 162.383 105.609 162.342 105.106C162.3 104.602 162.3 104.054 162.45 103.488C162.759 102.324 163.388 101.707 163.71 101.611C163.848 101.571 163.952 101.602 164.034 101.739C164.476 102.485 163.815 102.969 163.832 103.09C163.858 103.271 164.608 103.245 163.928 103.297C163.248 103.35 161.291 103.367 159.494 103.316C157.697 103.265 156.12 103.145 155.407 103.057C154.694 102.97 154.894 102.918 157.104 102.849C159.313 102.78 163.526 102.694 166.705 102.496C169.884 102.297 171.901 101.989 174.039 101.671",
    stroke: "#0F574E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.882,
    y: 14.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.617,
    y: 15.0566,
    width: 63.886,
    height: 43.8342,
    rx: 5.13,
    fill: "#E9FBF9"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.148 58.8906H177.734",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.305 44.9025C145.315 44.9025 145.325 44.9047 145.335 44.9047C145.345 44.9047 145.353 44.9029 145.362 44.9028C147.335 44.8936 149.224 44.1037 150.616 42.7058C152.008 41.308 152.789 39.4159 152.789 37.4436C152.789 35.4712 152.008 33.5792 150.616 32.1813C149.224 30.7834 147.335 29.9935 145.362 29.9843C145.353 29.9843 145.344 29.9824 145.335 29.9824C145.326 29.9824 145.315 29.9843 145.305 29.9845C143.33 29.991 141.438 30.7797 140.044 32.1778C138.65 33.576 137.867 35.4695 137.867 37.4435C137.867 39.4176 138.65 41.3111 140.044 42.7092C141.438 44.1074 143.33 44.8961 145.305 44.9025ZM139.536 39.6783C140.23 40.0703 141.119 40.3889 142.171 40.606C142.388 41.6568 142.706 42.5444 143.098 43.2379C142.289 42.9243 141.555 42.4458 140.942 41.833C140.329 41.2201 139.85 40.4863 139.536 39.6783ZM141.962 39.2838C140.089 38.8178 139.115 38.0427 139.115 37.4437C139.115 36.8447 140.089 36.07 141.962 35.6032C141.828 36.8264 141.828 38.0606 141.962 39.2838ZM145.335 31.2266H145.339C145.938 31.2307 146.71 32.2043 147.176 34.0727C145.952 33.9384 144.717 33.9384 143.493 34.0727C143.959 32.2045 144.731 31.2313 145.33 31.2266C145.332 31.2268 145.334 31.2266 145.335 31.2266ZM143.247 35.3567C144.632 35.1685 146.037 35.1685 147.422 35.3567C147.611 36.7413 147.611 38.1451 147.422 39.5298C146.037 39.7179 144.632 39.7179 143.247 39.5298C143.059 38.1451 143.059 36.7414 143.247 35.3567ZM143.493 40.814C144.717 40.9481 145.952 40.9481 147.176 40.814C146.711 42.6826 145.938 43.6559 145.339 43.6601H145.335C145.334 43.6601 145.332 43.6601 145.33 43.6601C144.731 43.6556 143.959 42.6824 143.493 40.8145V40.814ZM147.571 43.2379C147.963 42.5443 148.281 41.6567 148.498 40.6057C149.55 40.3887 150.439 40.0702 151.132 39.6783C150.819 40.4863 150.34 41.2202 149.727 41.8331C149.114 42.446 148.38 42.9246 147.571 43.2382L147.571 43.2379ZM148.707 35.6029C150.58 36.0693 151.555 36.8441 151.555 37.4434C151.555 38.0427 150.58 38.8175 148.707 39.2835C148.841 38.0603 148.841 36.8261 148.707 35.6029ZM151.133 35.2081C150.439 34.8163 149.55 34.4978 148.498 34.2808C148.281 33.2298 147.963 32.3421 147.571 31.6486C148.38 31.9622 149.114 32.4407 149.727 33.0536C150.34 33.6665 150.819 34.4004 151.133 35.2085V35.2081ZM143.097 31.6492C142.706 32.3427 142.387 33.2302 142.171 34.2811C141.118 34.4982 140.23 34.8168 139.536 35.2089C139.85 34.4009 140.329 33.6671 140.942 33.0542C141.555 32.4414 142.289 31.9629 143.097 31.6492Z",
    fill: "#168374"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M105.148 101.405V110.811C105.148 113.645 107.446 115.943 110.281 115.943H119.167",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M185 101.405V110.811C185 113.645 182.702 115.943 179.867 115.943H170.981",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.148 18.5953V9.18926C105.148 6.35459 107.446 4.05664 110.281 4.05664H119.167",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185 18.5953V9.18926C185 6.35459 182.702 4.05664 179.867 4.05664H170.981",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.485,
    cy: 15.7776,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.32 8.07227C168.776 8.07227 165.164 11.5598 165.164 15.9473C165.164 20.3348 168.776 23.8223 173.32 23.8223C177.865 23.8223 181.477 20.3348 181.477 15.9473C181.477 11.5598 177.865 8.07227 173.32 8.07227ZM176.466 19.8848L173.32 16.8473L170.174 19.8848L169.242 18.9848L172.388 15.9473L169.242 12.9098L170.174 12.0098L173.32 15.0473L176.466 12.0098L177.398 12.9098L174.252 15.9473L177.398 18.9848L176.466 19.8848Z",
    fill: "#FF6467"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6970_232986",
    x: 110.148,
    y: 11.5859,
    width: 70.8281,
    height: 96.9414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_6970_232986"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgClearImage);
export default __webpack_public_path__ + "static/media/img-clear-image.633c6ba41229b7005f1069ab30ef5c08.svg";
export { ForwardRef as ReactComponent };